import React, { ReactNode } from 'react'

import { SomethingWentWrongPage } from '../../../SomethingWentWrongPage'

export function FallbackComponent(): ReactNode {
  return <SomethingWentWrongPage />
}
